import { PersonalDataState } from '../types';

export interface InputConfig {
  key: keyof PersonalDataState;
  type: 'number' | 'text' | 'select' | 'date';
  disabled?: boolean;
}

export const personalDataElements: InputConfig[] = [
  {
    key: 'firstName',
    type: 'text',
  },
  {
    key: 'lastName',
    type: 'text',
  },
  {
    key: 'phoneNumber',
    type: 'number',
  },
  {
    key: 'birthDate',
    type: 'date',
  },
];

export const addressDataElements: InputConfig[] = [
  {
    key: 'zipCode',
    type: 'text',
  },
  {
    key: 'state',
    type: 'text',
    disabled: true,
  },
  {
    key: 'city',
    type: 'text',
    disabled: true,
  },
  {
    key: 'locality',
    type: 'text',
    disabled: true,
  },
];
